// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6136fd21","732":"8912eb5e","977":"4326ab30"}[chunkId] + ".chunk.js";
};